import { defineStore } from 'pinia'
import { useSessionStorage } from '@vueuse/core'
import { useRouter, useRoute } from 'vue-router'

export const useNavTabsStore = defineStore('navTabs', () => {
  const tabs = useSessionStorage('navTabs', [{ id: 0, text: 'Αρχική', to: '/home' }])

  const router = useRouter()
  const route = useRoute()

  const addTab = ({ text, to }) => {
    const tab = {
      id: tabs.value.length,
      text,
      to
    }
    tabs.value.push(tab)
    router.push(to)
  }

  const removeTab = (id) => {
    tabs.value = tabs.value.filter((tab) => tab.id !== id)
  }

  const removeCurrentTab = () => {
    tabs.value = tabs.value.filter((tab) => tab.to !== route.path)
    router.push(tabs.value.at(-1).to)
  }

  const reset = () => {
    tabs.value = [{ id: 0, text: 'Αρχική', to: '/home' }]
  }

  return {
    tabs,
    addTab,
    removeTab,
    removeCurrentTab,
    reset
  }
})
